import { render, staticRenderFns } from "./CandidateBulkReservationType.vue?vue&type=template&id=4d719b80&lang=pug&"
import script from "./CandidateBulkReservationType.vue?vue&type=script&lang=js&"
export * from "./CandidateBulkReservationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCol,VList,VSubheader})
